"use strict";

define('evisions/redactor.plugins/macro.redactor.plugin',['backbone.radio'], function (Radio) {
  if (typeof window.RedactorPlugins === 'undefined') window.RedactorPlugins = {};
  var channel = Radio.channel('global');
  window.RedactorPlugins.macro = {
    init: function init() {
      this.$box.addClass('redactor-macro-plugin');
      this.buttonAdd('clips', 'Insert Variable', this.showInsertMacroModal);
    },
    showInsertMacroModal: function showInsertMacroModal() {
      var macros = this.opts.macros || new Backbone.Collection(),
        range = this.getCaretOffsetRange().range;
      channel.request('build:messageTemplateTagModal', {
        collection: macros
      }).on('approve', function (value) {
        this.insertMacro(value, range);
      }, this);
    },
    insertMacro: function insertMacro(macro, range) {
      this.selectionSet(range.startContainer, range.startOffset, range.endContainer, range.endOffset);
      this.insertText(macro.get('macro'));
    }
  };
  return RedactorPlugins;
});

